import { z } from 'zod';

/** Type melding vanuit het feedbackformulier. */
export const FeedbackTypeSchema = z.enum(['bug', 'feature']);
export type FeedbackType = z.infer<typeof FeedbackTypeSchema>;

/** Body van POST /api/feedback. */
export const FeedbackBodySchema = z.object({
  type: FeedbackTypeSchema,
  title: z.string().trim().min(5, 'Titel is te kort (minimaal 5 tekens)').max(120),
  description: z.string().trim().min(10, 'Omschrijving is te kort (minimaal 10 tekens)').max(5000),
  /** Route in de app waar de melding over gaat (automatisch meegestuurd, vrij aanpasbaar). */
  page: z.string().trim().max(200).optional().default(''),
});
export type FeedbackBody = z.infer<typeof FeedbackBodySchema>;

/** Antwoord na registratie: het aangemaakte GitHub-issue. */
export const FeedbackResultSchema = z.object({
  issueNumber: z.number().int(),
  issueUrl: z.string(),
});
export type FeedbackResult = z.infer<typeof FeedbackResultSchema>;
